import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_routing_overview_cancel_open_qty",
  ref: "orderRoutingCancelOpenQtyRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-400px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_routing_overview_cancel_open_qty_header"
}
const _hoisted_5 = { class: "w-100 d-flex align-items-center justify-content-between" }
const _hoisted_6 = { class: "fw-bolder" }
const _hoisted_7 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "modal-body p-0" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-12 form-group" }
const _hoisted_14 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_15 = { class: "modal-footer flex-right" }
const _hoisted_16 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_17 = { class: "indicator-label" }
const _hoisted_18 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_19 = { class: "indicator-progress" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.t("orderAssign.toBeCanceled")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_form, {
            model: _ctx.formData,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_el_form_item, { prop: "ids" }, null, 512), [
                [_vShow, false]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_el_popover, {
                        placement: "top",
                        width: "auto",
                        trigger: "hover"
                      }, {
                        reference: _withCtx(() => [
                          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("orderAssign.cancelQty")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_ctx.t("orderAssign.plsCancelQty")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { prop: "quantity" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input_number, {
                            class: "text-start w-100",
                            modelValue: _ctx.formData.quantity,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.quantity) = $event)),
                            precision: 0,
                            step: 1,
                            min: 1,
                            max: _ctx.tableItemData.allow_cancel_qty,
                            controls: false
                          }, null, 8, ["modelValue", "max"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])), [
                [_directive_loading, _ctx.loading]
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-light me-3",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
                }, [
                  _createElementVNode("span", _hoisted_16, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.cancel")), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-lg btn-primary",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                }, [
                  _createElementVNode("span", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.confirm")), 1)
                  ]),
                  _createElementVNode("span", _hoisted_19, [
                    _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                    _hoisted_20
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ])
    ])
  ], 512))
}